import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getForum = async (token, baseUrl, projectId, forumId) => {
  const queryPath = `${baseUrl}/projects/${projectId}/forums/${forumId}`;

  try {
    const res = await get(token, queryPath);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
